
































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { DxSwitch } from "devextreme-vue/switch";

@Component({
  components: {
    DxSwitch,
  },
})
export default class ProjectStats extends Vue {
  @Prop({ required: true })
  private stats!: IProjectStatistics;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  public change() {
    this.$emit("save", this.stats.completed);
  }

  get relativeTurnoverPercentage() {
    // Relative to estimation
    const result =
      Math.round(
        (this.stats.effectiveTurnover / this.stats.estimatedTurnover) * 10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get relativeEffectiveLabourCost() {
    const result =
      Math.round(
        (this.stats.effectiveLabourCost / this.stats.effectiveTotalCosts) *
          10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get relativeEffectiveMaterialCost() {
    const result =
      Math.round(
        (this.stats.effectiveMaterialCost / this.stats.effectiveTotalCosts) *
          10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get relativeEffectiveVariaCost() {
    const result =
      Math.round(
        (this.stats.effectiveVariaCost / this.stats.effectiveTotalCosts) * 10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get LabourCostRelativeToTurnover() {
    const result =
      Math.round(
        (this.stats.effectiveLabourCost / this.stats.effectiveTurnover) * 10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get MaterialCostRelativeToTurnover() {
    const result =
      Math.round(
        (this.stats.effectiveMaterialCost / this.stats.effectiveTurnover) *
          10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get VariaCostRelativeToTurnover() {
    const result =
      Math.round(
        (this.stats.effectiveVariaCost / this.stats.effectiveTurnover) * 10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get ProfitRelativeToTurnover() {
    const result =
      Math.round(
        (this.stats.effectiveProfit / this.stats.effectiveTurnover) * 10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get EstimatedLabourCostRelativeToTurnover() {
    const result =
      Math.round(
        (this.stats.estimatedLabourCost / this.stats.estimatedTurnover) * 10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get EstimatedMaterialCostRelativeToTurnover() {
    const result =
      Math.round(
        (this.stats.estimatedMaterialCost / this.stats.estimatedTurnover) *
          10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }

  get EstimatedProfitRelativeToTurnover() {
    const result =
      Math.round(
        (this.stats.estimatedProfit / this.stats.estimatedTurnover) * 10000
      ) / 100;
    if (isNaN(result)) {
      return 100;
    }

    return result;
  }
}
